import type { PlayerGraphNode } from "../../lib/core/engine/PlayerGraphNode/PlayerGraphNode.type"

const cache : WeakMap<PlayerGraphNode, Map<string, Promise<OffscreenCanvas>>> = new WeakMap

export default function getFromCacheOrCreateIconOffscreenCanvas(
  pg: PlayerGraphNode,
  key: string,
  fn: () => Promise<OffscreenCanvas>,
): Promise<OffscreenCanvas> {
  let map = cache.get(pg)
  if (!map) {
    map = new Map
    cache.set(pg, map)
  }
  let promise = map.get(key)
  if (!promise) {
    promise = fn()
    map.set(key, promise)

    // console.log('map', map)
  }
  return promise
}
